module.exports = __webpack_public_path__ + "static/media/Tick-White.3a4ae4f3.svg";